import React,{useState} from "react";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useHistory } from "react-router-dom";
const Product = (props) =>{
    const [like,setLike] = useState(false)
    const history = useHistory()
    return (
        <div id="item_img"
        >
        {
            like === false ?
            <FavoriteBorderIcon 
            onClick={(()=>{
                if(like === true){
                    setLike(false)
                }else{
                    setLike(true) 
                }
                
            })} 
            id="wish_product_icon" />:
            <FavoriteIcon 
             style={{color:"red"}} 
            onClick={(()=>{
               if(like === true){
                   setLike(false)
               }else{
                   setLike(true) 
               }
               
           })} 
           id="wish_product_icon" />

        }
        <div
           onClick={(()=>{
            history.push({
                pathname:`/product/:${props.data.name}`,
                state:{
                    product:props.data
                }
            })
         })}
        >
        <img src={props.data.imgs[1]} alt=""/>
        <hr id="line_grid_3_system_img"/>
        <p id="item_img_title">{props.data.name}</p>
        <p id="item_img_price">{props.data.price}</p>
        </div>
    
        </div>
    )
}
export default Product;